import { css } from 'styled-components';

const mapNavHoverCss = css`
  background: var(--color-mapNavBackground);
`;

const listElementHoverCss = css`
  background: var(--color-primary-05);
`;

export { listElementHoverCss, mapNavHoverCss };
